module.exports = __webpack_public_path__ + "img/493.9ea3b338.jpg";